import { PiggyBank } from "lucide-react";
import type { DashboardTarget } from "@/lib/api/dashboard";
import { useDashboardWidget } from "@/lib/hooks/use-dashboard";
import { useT } from "@/lib/i18n/use-t";
import { useDashboardFormat } from "../use-dashboard-format";
import { KeyFigureValue } from "./key-figure-value";
import { T } from "./saving-inflow-widget.i18n";
import { StatsCard } from "./stats-card";

export function SavingInflowWidget({ target }: { target: DashboardTarget }) {
  const { data, isLoading, error } = useDashboardWidget("saving_inflow", target);
  const t = useT(T);
  const { compactMoney, count } = useDashboardFormat();
  return (
    <StatsCard
      icon={PiggyBank}
      label={t.savingInflow}
      value={
        <KeyFigureValue isLoading={isLoading} error={error}>
          {data && compactMoney(data.amount, data.currency)}
        </KeyFigureValue>
      }
      subtitle={
        data && (data.planCount === 1 ? t.fromPlansOne : t.fromPlans(count(data.planCount)))
      }
    />
  );
}
